import styled from 'styled-components'

export const BaseButtonWrap = styled.div`
  display: flex;
  & button {
    text-transform: none;
  }
`
